<template>
  <div class="driver-bar-wrap">
    <div v-if="isLoading" style="position: absolute;left:40%;top:30%;z-index: 99;">
      <v-btn :loading="true" text x-large fab></v-btn>
      <div class="pl-1">Loading...</div>
    </div>
    <div id="rateBarGraph"></div>
    <div v-if="chartData && chartData.length === 0 && !isLoading">
      <div class="am-no-data">
        Not enough data to generate analysis
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

export default {
  name: 'DriverBar',

  props: {
    chartData: {
      required: true,
      type: [Array, Object]
    }
  },

  data () {
    return {
      isLoading: true
    };
  },

  watch: {
    chartData: {
      deep: true,
      handler () {
        if (this.chartData && this.chartData.length > 0) {
          this.createChart(this.chartData);
        } else {
          this.isLoading = false;
        }
      }
    }
  },

  // mounted () {
  //   this.createChart();
  // },

  beforeDestroy () {
    am4core.disposeAllCharts();
  },

  methods: {
    createChart (val) {
      var chart = am4core.create('rateBarGraph', am4charts.XYChart);
      chart.preloader.disabled = true;
      const that = this;
      chart.events.on('ready', function (ev) {
        that.isLoading = false;
      });
      chart.data = val;
      chart.cursor = new am4charts.XYCursor();
      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'key';
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.line.strokeOpacity = 1;
      categoryAxis.renderer.line.strokeWidth = 1.5;
      categoryAxis.renderer.line.stroke = am4core.color('#050550');
      categoryAxis.renderer.cellStartLocation = 0.1;
      categoryAxis.renderer.cellEndLocation = 0.8;
      const label = categoryAxis.renderer.labels.template;
      label.truncate = true;
      label.fontSize = 11;
      // label.wrap = true;
      label.maxWidth = 90;
      label.hideOversized = false;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 1.5;
      valueAxis.renderer.line.stroke = am4core.color('#050550');
      valueAxis.renderer.minWidth = 10;
      valueAxis.min = 0;
      // valueAxis.max = 100;
      valueAxis.strictMinMax = true;

      // Create series
      var series = chart.series.push(new am4charts.ColumnSeries());
      // series.columns.template.tooltipText = 'Category: {categoryX}\nValue: {valueY}';
      series.sequencedInterpolation = true;
      series.dataFields.valueY = 'value';
      series.dataFields.categoryX = 'key';
      series.columns.template.strokeWidth = 0;
      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
      series.columns.template.column.fill = '#050550';
      series.strokeWidth = 0;
      series.columns.template.fill = '#050550';
      series.columns.template.fillOpacity = 0.8;
      series.columns.template.strokeOpacity = 0;
      series.columns.template.tooltipHTML = `<center><strong>{categoryX}</strong></center>
      <hr />
      <table>
      <tr>
        <td>{valueY}/5</td>
      </tr>
      </table>`;
      series.columns.template.width = am4core.percent(50);
      chart.scrollbarX = new am4core.Scrollbar();
      // Pre-zoom the chart
      if (val && val.length > 10) {
        chart.events.on('ready', function () {
          categoryAxis.zoomToIndexes(0, 10);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.am-no-data {
  position: absolute;
  top: 45%;
  // left: 35%;
  // height: 20rem;
  width: 100%;
}
.driver-bar-wrap {
  position: relative;
  #rateBarGraph {
    height: 25rem;
  }
}
</style>
